module.exports = __webpack_public_path__ + "static/img/greengold.9f65bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/greengold.png
// module id = /Qyw
// module chunks = 1